import { types } from '../actions/jobAlerts';

const initialState = {
  pendingFlag: false,
  error: '',
  createPending: false,
  createError: '',
  updatePending: false,
  updateError: '',
  deletePending: false,
  deleteError: '',
  alerts: []
};

export default function reduce(state = initialState, action) {
  switch (action.type) {
    case types.GET_ALL_JOB_ALERTS_PENDING:
      return {
        ...state,
        error: '',
        pendingFlag: true
      };
    case types.GET_ALL_JOB_ALERTS_REJECTED:
      return {
        ...state,
        error: action.payload?.response?.data,
        pendingFlag: false
      };
    case types.GET_ALL_JOB_ALERTS_FULFILLED:
      return {
        ...state,
        error: '',
        pendingFlag: false,
        alerts: [...action.payload.Data]
      };
    case types.CREATE_NEW_JOB_ALERT_PENDING:
      return {
        ...state,
        createError: '',
        createPending: true
      };
    case types.CREATE_NEW_JOB_ALERT_REJECTED:
      return {
        ...state,
        createError: action.payload?.response?.data,
        createPending: false
      };
    case types.CREATE_NEW_JOB_ALERT_FULFILLED:
      return {
        ...state,
        createError: '',
        createPending: false,
        alerts: [...state.alerts, action.payload]
      };
    case types.EDIT_JOB_ALERT_PENDING:
      return {
        ...state,
        updateError: '',
        updatePending: true
      };
    case types.EDIT_JOB_ALERT_REJECTED:
      return {
        ...state,
        updateError: action.payload?.response?.data,
        updatePending: false
      };
    case types.EDIT_JOB_ALERT_FULFILLED:
      return {
        ...state,
        updateError: '',
        updatePending: false,
        alerts: state.alerts.map((alert) => (alert.Id === action.payload?.Id ? action.payload : alert))
      };
    case types.DELETE_JOB_ALERT_PENDING:
      return {
        ...state,
        deleteError: '',
        deletePending: true
      };
    case types.DELETE_JOB_ALERT_REJECTED:
      return {
        ...state,
        deleteError:
          action.payload?.response.status !== 500
            ? action.payload?.response?.data?.message
            : action.payload?.response?.data,
        deletePending: false
      };
    case types.DELETE_JOB_ALERT_FULFILLED:
      return {
        ...state,
        deleteError: '',
        deletePending: false,
        alerts: state.alerts.filter((alert) => alert.Id !== action.payload)
      };
    default:
      return state;
  }
}
